import { useEffect, useRef, useState } from "react";
import { TbReport } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, getDateAndTime, handleDateChange, sanitizeInput } from "../CommonComponents/CustomHooks";
import { CommonApiData, initializeFilterData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, RadioButton, SelectInputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const BookingReport = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const GetShipmentStatus = DropDownData('GetPacketStatus')
    const loginUserClientCode = CommonApiData().loginUserClientCode;

    //const data = CommonApiData();

    const initialFormData = {
        pickupDateFrom: getDateAndTime(7).date,
        pickupDateTo: getDateAndTime().date,
        client: loginUserClientCode,
        reportType: "summarised",
        docketNo: '',
        boxNo: '',
        status: '',
    }

    const [formData, setFormData] = useState(initialFormData);
    //const GetGroupName = DropDownData('GetGroupNameUserWise', data.loginUserGroupID,)

    const GetBookingReport = async (CurrentPage, initialData) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            "PageIndex": PageIndex.toString(),
            ...sortConfig,
            ...(initialData || formData)
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Shipment/ShipmentReport`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res?.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData(initialFormData);
        GetBookingReport(1, initialFormData)
    }

    const handleChange1 = (i, p) => {
        GetBookingReport(p)
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleLabelPrint = async (value) => {
        window.open(value, '_blank');
    }
    const handleCNPrint = async (value) => {
        window.open(value, '_blank');
    }

    useEffect(() => {
        document.title = 'Shipment Report'
        inputrefs.current['txtPickupDateFrom'].focus()
    }, [])
        ;

    useEffect(() => {
        GetBookingReport();
    }, [sortConfig]);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3'>


                <div className="flex flex-col sm:flex-row sm:items-center mb-2 gap-2">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                        <div className="flex items-center gap-2">
                            <TbReport className="w-5 h-5 sm:w-6 sm:h-6 text-primary-600" />
                            <h2 className="text-lg sm:text-xl font-semibold text-primary-600">
                                Shipment Report
                            </h2>
                        </div>
                        <div className="flex items-center gap-3 flex-wrap mb-2 ms-3">
                            <RadioButton
                                divclassname="flex items-center "
                                id="txtSummarised"
                                name="reportType"
                                label="Summarised"
                                value="summarised"
                                checked={formData.reportType === "summarised"}
                                inputrefs={inputrefs}
                                onChange={(e) =>
                                    setFormData({ ...formData, reportType: e.target.value })
                                }

                            />
                            <RadioButton
                                divclassname="flex items-center"
                                id="txtDetailed"
                                name="reportType"
                                label="Detailed"
                                value="detailed"
                                checked={formData.reportType === "detailed"}
                                inputrefs={inputrefs}
                                onChange={(e) =>
                                    setFormData({ ...formData, reportType: e.target.value })
                                }

                            />
                        </div>
                    </div>
                </div>
                <div className="card-body grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                        {/* From Date */}
                        <DateBox
                            inputrefs={inputrefs}
                            label="From Date"
                            placeholder="DD-MMM-YYYY"
                            id="txtPickupDateFrom"
                            selected={
                                formData?.pickupDateFrom
                                    ? new Date(formData.pickupDateFrom)
                                    : null
                            }
                            onChange={(date) =>
                                handleDateChange(date, setFormData, formData, 'pickupDateFrom')
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtPickupDateTo']?.focus()
                                }
                            }}
                        />

                        {/* To Date */}
                        <DateBox
                            inputrefs={inputrefs}
                            label="To Date"
                            placeholder="DD-MMM-YYYY"
                            id="txtPickupDateTo"
                            selected={
                                formData?.pickupDateTo
                                    ? new Date(formData.pickupDateTo)
                                    : null
                            }
                            onChange={(date) =>
                                handleDateChange(date, setFormData, formData, 'pickupDateTo')
                            }

                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtDocketNo']?.focus()
                                }
                            }}
                        />
                    </div>

                    <InputBox
                        id="txtDocketNo"
                        label="Docket No"
                        placeholder="Enter Docket No"
                        inputrefs={inputrefs}
                        value={formData.docketNo || ''}
                        onChange={(e) => {
                            setFormData({ ...formData, docketNo: sanitizeInput(e.target.value) })
                        }}

                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSub']?.focus();
                            }
                        }}
                    />

                    <AutoCompleteBoxNew
                        id="txtClient"
                        value={formData.client}
                        label='Client'
                        disabled
                        placeholder="Enter Client "
                        autocompleteType="GetClient"
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';
                            if (event.type !== 'keydown') {
                                const updatedData = { ...formData, client: newInputValue };
                                setFormData(updatedData);
                            }
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSub']?.focus();
                            }
                        }}
                    />
                    
                    {/*{formData.reportType === "detailed" &&*/}
                    {/*    <InputBox*/}
                    {/*    id="txtBoxNo"*/}
                    {/*    label="Box No"*/}
                    {/*    placeholder="Enter Box No"*/}
                    {/*    inputrefs={inputrefs}*/}
                    {/*    value={formData.boxNo || ''}*/}
                    {/*    onChange={(e) => {*/}
                    {/*        setFormData({ ...formData, boxNo: sanitizeInput(e.target.value) })*/}
                    {/*    }}*/}

                    {/*    onKeyDown={(e) => {*/}
                    {/*        if (e.key === 'Enter') {*/}
                    {/*            e.preventDefault();*/}
                    {/*            inputrefs.current['txtShipmentStatus']?.focus();*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*/>}*/}


                    {/*<SelectInputBox*/}
                    {/*    id="txtShipmentStatus"*/}
                    {/*    value={formData.status}*/}
                    {/*    label='Shipment Status'*/}
                    {/*    onChange={(e) => setFormData({ ...formData, status: e.target.value })}*/}
                    {/*    inputrefs={inputrefs}*/}
                    {/*    onKeyDown={(e) => {*/}
                    {/*        if (e.key === 'Enter') {*/}
                    {/*            inputrefs.current['txtSalesPerson'].focus()*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <option value=''>--Please Select--</option>*/}
                    {/*    {GetShipmentStatus?.data?.dropDownData?.map((item, index) =>*/}
                    {/*        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>*/}
                    {/*    )}*/}
                    {/*</SelectInputBox>*/}

                </div>

                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSearch={GetBookingReport}

                        search={true}
                        save={false}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            handleDownloadExcel(`/api/Shipment/ShipmentReport`, { ...filterData, ...formData }, 'Shipment Report')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                </div>
            </div>

            <div className=" mt-3">
                <Table
                    loading={isLoading}
                    PageName={'a'}
                    handleFilter={() => {
                        GetBookingReport()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    Filter={false}
                    onlyFilterPage={true}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    sortConfig={sortConfig}
                    handleSorting={handleSorting}
                    handleCNPrint={handleCNPrint}
                    handleLabelPrint={handleLabelPrint}
                />
            </div>
        </>
    )
}
export default BookingReport;